import { StyledToolbarButton, StyledTooltip } from '../../../../../shared/styles/components/integrations.styles';
import { canCreateMissingParts, getSubItemMatchKey } from '../utils/copy-paste.utils';
import { useMemo, useState } from 'react';

import { CountBadge } from './CopyPaste.styles';
import { PasteTheatre } from './PasteTheatre';
import clipboardCheckmark from '@ingka/ssr-icon/paths/clipboard-checkmark';
import { useParentItemsFromSelectedSubItems } from '../../../state/selection.state';
import { useCopyParts } from '../../../state/copy-paste.state';

export const PasteButton = () => {
    const selectedItems = useParentItemsFromSelectedSubItems(true);
    const { hasCopiedParts, copiedParts, familyName } = useCopyParts();
    const [isOpen, setIsOpen] = useState(false);

    const resolvedSelectedItems = useMemo(
        () => {
            const copiedParentIds = new Set(copiedParts.map((cp) => cp.parentId));
            return selectedItems.filter((item) => !copiedParentIds.has(item.itemNo));
        },
        [selectedItems, copiedParts]
    );

    const canPasteAnything = useMemo(() => {
        if (canCreateMissingParts(copiedParts)) return true;
        const copiedKeys = new Set(copiedParts.map(getSubItemMatchKey));
        return resolvedSelectedItems.some((item) =>
            item.subItems.some((s) => copiedKeys.has(getSubItemMatchKey(s)))
        );
    }, [copiedParts, resolvedSelectedItems]);

    if (!hasCopiedParts || resolvedSelectedItems.length === 0) return null;

    return (
        <>
            <StyledTooltip
                title={
                    canPasteAnything
                        ? 'Paste part(s) into selected items'
                        : 'Nothing to paste — the selected items have no matching parts, and the copied parts can not be created (only user/application-created parts can be).'
                }
            >
                <span>
                    <StyledToolbarButton
                        ssrIcon={clipboardCheckmark}
                        text="Paste"
                        iconOnly={true}
                        small={true}
                        onClick={() => setIsOpen(true)}
                        disabled={!canPasteAnything}
                    >
                        <CountBadge>{copiedParts.length}</CountBadge>
                    </StyledToolbarButton>
                </span>
            </StyledTooltip>
            {isOpen && (
                <PasteTheatre
                    copiedParts={copiedParts}
                    resolvedSelectedItems={resolvedSelectedItems}
                    familyName={familyName}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
};
